import React from "react";

type Props = {
  prefix: string;
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function PrefixInput({ prefix, placeholder, value, onChange }: Props) {
  return (
    <div className="h-[38px] w-full overflow-hidden rounded-lg border border-[#D6DADF] bg-white flex">
      <span className="select-none grid place-items-center px-3 min-w-[140px] text-sm text-[#6F757A] bg-[#ECEDEE]">
        {prefix}
      </span>
      <input
        className="flex-1 px-3 outline-none text-sm placeholder:text-[#A8ADB3] bg-white"
        placeholder={placeholder ?? "company"}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}
